export default "__VITE_ASSET__Mw4u97FG__"